import React, { useEffect, useState } from 'react';
import { doc, query, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase/clientApp';
import { IMAGES, PROPERTIES, USERS } from '../../firebase';
import { PicturePlaceholder } from '.';
import { useUser } from '../hooks/useUser';
import classNames from '../utility/classNames';
import { useParams } from 'react-router-dom';

export default function PropertyPicture({
  property,
  classes = '',
  placeHolderClasses,
}) {
  const { propertyId, coverImageId } = property;
  const { uid } = useParams();
  const { user } = useUser();
  const [image, setImage] = useState(null);
  const [error, setError] = useState(null);

  const imageRef = query(
    doc(
      db,
      `${USERS}/${
        uid || user.uid
      }/${PROPERTIES}/${propertyId}/${IMAGES}/${coverImageId}`
    )
  );

  useEffect(() => {
    const unsubscribeFromImage = onSnapshot(
      imageRef,
      (doc) => {
        if (!doc.exists()) return;
        const data = doc.data();
        setImage(data);
      },
      (error) => {
        setError('Error loading image data: ', error);
      }
    );

    // Clean up the listener
    return () => unsubscribeFromImage();
  }, [coverImageId]);

  // const [image, loading, error] = useDocumentData(imageRef);
  if (error || !image) {
    if (error) console.error(error);
    return (
      <PicturePlaceholder
        classes={classNames('text-lg bg-white', placeHolderClasses)}
      />
    );
  }

  return (
    <img
      src={image?.photoUrlBE || image?.fileUrlBE}
      alt="Property Image"
      className={classNames(
        'w-full h-full object-center object-cover',
        classes
      )}
    />
  );
}
